module.exports = __webpack_public_path__ + "static/media/filling-purple.df3750e9.png";